import styles from '@/styles/Forms.module.scss'
import classnames from 'classnames'

export const HelperTextExtended = ({
  children,
  hasError,
}: {
  children: React.ReactNode
  hasError?: boolean
}) => {
  return (
    <div
      className={classnames(
        styles.helperTextExtended,
        hasError && styles.error
      )}
    >
      {children}
    </div>
  )
}
